import { render } from "./MidnightTarget.vue?vue&type=template&id=d3aa4fea"
import script from "./MidnightTarget.vue?vue&type=script&lang=js"
export * from "./MidnightTarget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__